import type { MenuSection } from '@1js/acui-menu/lib/components/MenuDefinition';
import { MailRibbonTabId } from 'owa-ribbon-ids';
import {
    createMailGeneratedMenuItem,
    createMailGeneratedMenuFlyoutAnchor,
} from '../../util/createMailRibbonButton';
import type { MenuItemControlProps } from '@1js/acui-ribbon-like/lib/UISurfaces/controls/Menu';
import { options_readingPane_quickSetting_label } from 'owa-reading-pane-option/lib/lazyQuickOption.locstring.json';
import loc from 'owa-localize';
import ReadingPanePosition from 'owa-session-store/lib/store/schema/ReadingPanePosition';
import {
    options_readingPane_quickSetting_right,
    options_readingPane_quickSetting_bottom,
    options_readingPane_quickSetting_classic,
} from 'owa-reading-pane-option/lib/components/ReadingPaneQuick.locstring.json';
import { onReadingPanePositionClicked, onToggleFolderPane } from '../../util/commandActions';
import { getUserConfiguration } from 'owa-session-store';
import Strings from 'owa-locstrings/lib/strings/ribbon_mail_buttons_and_tabs.locstring.json';
import { isFeatureEnabled } from 'owa-feature-flags';
import { shouldShowFolderPane } from 'owa-mail-layout';

export default function getLayoutSections(tabId?: MailRibbonTabId): MenuSection[] {
    let sections: MenuItemControlProps[] = [];

    if (isFeatureEnabled('mon-tri-collapsibleFolderPane')) {
        // add folder menu
        sections.push(
            createMailGeneratedMenuFlyoutAnchor(
                Strings.folder_Button,
                loc(Strings.folder_Button),
                undefined /*tooltip*/,
                {
                    sections: [
                        {
                            controls: getFolderMenuOptions(),
                        },
                    ],
                },
                undefined /* keytipProps */,
                false
            )
        );
    }

    // add reading pane menu
    sections.push(
        createMailGeneratedMenuFlyoutAnchor(
            options_readingPane_quickSetting_label,
            loc(options_readingPane_quickSetting_label),
            undefined /*tooltip*/,
            {
                sections: [
                    {
                        controls: getReadingPaneOptions(),
                    },
                ],
            },
            undefined /* keytipProps */,
            false
        )
    );

    return [
        {
            controls: sections,
        },
    ];
}

export function getReadingPaneOptions() {
    let sections: MenuItemControlProps[] = [];

    const currentSelection = getUserConfiguration().UserOptions?.GlobalReadingPanePositionReact;
    const readingPanePositions: { position: ReadingPanePosition; label: string }[] = [
        { position: ReadingPanePosition.Right, label: loc(options_readingPane_quickSetting_right) },
        {
            position: ReadingPanePosition.Bottom,
            label: loc(options_readingPane_quickSetting_bottom),
        },
        { position: ReadingPanePosition.Off, label: loc(options_readingPane_quickSetting_classic) },
    ];

    readingPanePositions.forEach(item => {
        sections.push(
            createMailGeneratedMenuItem(
                item.position,
                item.label,
                undefined /*tooltip*/,
                () => {
                    onReadingPanePositionClicked(item.position);
                },
                undefined /* keytipProps */,
                currentSelection === item.position
            )
        );
    });

    return sections;
}

export function getFolderMenuOptions() {
    const hideLeftPane = !shouldShowFolderPane();
    return [
        createMailGeneratedMenuItem(
            1,
            loc(Strings.folderMenu_Show),
            undefined /*tooltip*/,
            () => {
                onToggleFolderPane();
            },
            undefined /* keytipProps */,
            !hideLeftPane
        ),
        createMailGeneratedMenuItem(
            0,
            loc(Strings.folderMenu_Hide),
            undefined /*tooltip*/,
            () => {
                onToggleFolderPane();
            },
            undefined /* keytipProps */,
            hideLeftPane
        ),
    ];
}
